import { createFileRoute } from "@tanstack/react-router";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { TicketTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/rules",
)({
	component: OrgTicketTypeRulesTab,
});

function OrgTicketTypeRulesTab() {
	const { ticketType } = useTicketTypeDrawerContext();

	return (
		<div className="px-5 pb-5">
			<TicketTypeRulesSection
				ticketType={ticketType}
				scope="organization"
				stayOnRoute
			/>
		</div>
	);
}
